import React from 'react'
import BaseIcon from 'react-icon-base'

const DatePickerClearArrow = props => (
  <BaseIcon viewBox="0 0 20 12" {...props}>
    <g>
      <path
        fill="#C4CCD5"
        fillRule="evenodd"
        d="M10.172 4.586L11.586 6l-1.414 1.414 1.414 1.415L13 7.414l1.415 1.415 1.414-1.415L14.415 6l1.414-1.414-1.414-1.414L13 4.586l-1.414-1.414-1.414 1.414zM8.667 10H18V2H8.667L3.334 6l5.333 4zM8 0h12v12H8L0 6l8-6z"
      />
    </g>
  </BaseIcon>
)

export default DatePickerClearArrow
